export { default as Skeleton } from "react-loading-skeleton";
